<template>

  <section class="column_content">

    <h3 class="mb-3">2025.11.19 到着</h3>
    <div class="album_wrap">
      <img src="@/assets/img/album/202511/arrival_1.jpg" class="js-album-item">
      <img src="@/assets/img/album/202511/arrival_2.jpg" class="js-album-item">
      <img src="@/assets/img/album/202511/arrival_3.jpg" class="js-album-item">
      <img src="@/assets/img/album/202511/arrival_5.jpg" class="js-album-item">
      <img src="@/assets/img/album/202511/arrival_6.jpg" class="js-album-item">
      <img src="@/assets/img/album/202511/arrival_7.jpg" class="js-album-item">
      <img src="@/assets/img/album/202511/arrival_8.jpg" class="js-album-item">
      <img src="@/assets/img/album/202511/arrival_9.jpg" class="js-album-item">
      <img src="@/assets/img/album/202511/arrival_10.jpg" class="js-album-item">
      <img src="@/assets/img/album/202511/arrival_11.jpg" class="js-album-item">
      <img src="@/assets/img/album/202511/arrival_12.jpg" class="js-album-item">
      <img src="@/assets/img/album/202511/arrival_13.jpg" class="js-album-item">
      <img src="@/assets/img/album/202511/arrival_14.jpg" class="js-album-item">
      <img src="@/assets/img/album/202511/arrival_15.jpg" class="js-album-item">
    </div>
    
    <h3 class="mb-3">2025.11.19 ウェルカムパーティ</h3>
    <div class="album_wrap">
      <img src="@/assets/img/album/202511/welcome_1.jpg" class="js-album-item">
      <img src="@/assets/img/album/202511/welcome_2.jpg" class="js-album-item">
      <img src="@/assets/img/album/202511/welcome_3.jpg" class="js-album-item">
      <img src="@/assets/img/album/202511/welcome_4.jpg" class="js-album-item">
      <img src="@/assets/img/album/202511/welcome_5.jpg" class="js-album-item">
      <img src="@/assets/img/album/202511/welcome_6.jpg" class="js-album-item">
      <img src="@/assets/img/album/202511/welcome_7.jpg" class="js-album-item">
      <img src="@/assets/img/album/202511/welcome_8.jpg" class="js-album-item">
      <img src="@/assets/img/album/202511/welcome_9.jpg" class="js-album-item">
      <img src="@/assets/img/album/202511/welcome_10.jpg" class="js-album-item">
      <img src="@/assets/img/album/202511/welcome_11.jpg" class="js-album-item">
      <img src="@/assets/img/album/202511/welcome_12.jpg" class="js-album-item">
      <img src="@/assets/img/album/202511/welcome_13.jpg" class="js-album-item">
      <img src="@/assets/img/album/202511/welcome_14.jpg" class="js-album-item">
      <img src="@/assets/img/album/202511/welcome_15.jpg" class="js-album-item">
      <img src="@/assets/img/album/202511/welcome_16.jpg" class="js-album-item">
      <img src="@/assets/img/album/202511/welcome_17.jpg" class="js-album-item">
      <img src="@/assets/img/album/202511/welcome_18.jpg" class="js-album-item">
      <img src="@/assets/img/album/202511/welcome_19.jpg" class="js-album-item">
      <img src="@/assets/img/album/202511/welcome_20.jpg" class="js-album-item">
      <img src="@/assets/img/album/202511/welcome_21.jpg" class="js-album-item">
      <img src="@/assets/img/album/202511/welcome_22.jpg" class="js-album-item">
      <img src="@/assets/img/album/202511/welcome_23.jpg" class="js-album-item">
      <img src="@/assets/img/album/202511/welcome_24.jpg" class="js-album-item">
    </div>
    
    <h3 class="mb-3">2025.11.20 西表島</h3>
    <div class="album_wrap">
      <img src="@/assets/img/album/202511/iriomote_1.jpg" class="js-album-item">
      <img src="@/assets/img/album/202511/iriomote_2.jpg" class="js-album-item">
      <img src="@/assets/img/album/202511/iriomote_3.jpg" class="js-album-item">
      <img src="@/assets/img/album/202511/iriomote_4.jpg" class="js-album-item">
      <img src="@/assets/img/album/202511/iriomote_5.jpg" class="js-album-item">
      <img src="@/assets/img/album/202511/iriomote_6.jpg" class="js-album-item">
      <img src="@/assets/img/album/202511/iriomote_7.jpg" class="js-album-item">
      <img src="@/assets/img/album/202511/iriomote_8.jpg" class="js-album-item">
      <img src="@/assets/img/album/202511/iriomote_9.jpg" class="js-album-item">
      <img src="@/assets/img/album/202511/iriomote_10.jpg" class="js-album-item">
      <img src="@/assets/img/album/202511/iriomote_11.jpg" class="js-album-item">
      <img src="@/assets/img/album/202511/iriomote_12.jpg" class="js-album-item">
      <img src="@/assets/img/album/202511/iriomote_13.jpg" class="js-album-item">
      <img src="@/assets/img/album/202511/iriomote_14.jpg" class="js-album-item">
      <img src="@/assets/img/album/202511/iriomote_15.jpg" class="js-album-item">
      <img src="@/assets/img/album/202511/iriomote_16.jpg" class="js-album-item">
      <img src="@/assets/img/album/202511/iriomote_17.jpg" class="js-album-item">
    </div>
    
    <h3 class="mb-3">2025.11.20 竹富島</h3>
    <div class="album_wrap">
      <img src="@/assets/img/album/202511/taketomi_1.jpg" class="js-album-item">
      <img src="@/assets/img/album/202511/taketomi_2.jpg" class="js-album-item">
      <img src="@/assets/img/album/202511/taketomi_3.jpg" class="js-album-item">
      <img src="@/assets/img/album/202511/taketomi_4.jpg" class="js-album-item">
      <img src="@/assets/img/album/202511/taketomi_5.jpg" class="js-album-item">
      <img src="@/assets/img/album/202511/taketomi_6.jpg" class="js-album-item">
      <img src="@/assets/img/album/202511/taketomi_7.jpg" class="js-album-item">
      <img src="@/assets/img/album/202511/taketomi_8.jpg" class="js-album-item">
      <img src="@/assets/img/album/202511/taketomi_9.jpg" class="js-album-item">
      <img src="@/assets/img/album/202511/taketomi_10.jpg" class="js-album-item">
      <img src="@/assets/img/album/202511/taketomi_11.jpg" class="js-album-item">
      <img src="@/assets/img/album/202511/taketomi_12.jpg" class="js-album-item">
      <img src="@/assets/img/album/202511/taketomi_13.jpg" class="js-album-item">
      <img src="@/assets/img/album/202511/taketomi_14.jpg" class="js-album-item">
    </div>
    
    <h3 class="mb-3">2025.11.20 島内観光</h3>
    <div class="album_wrap">
      <img src="@/assets/img/album/202511/kankou_1.jpg" class="js-album-item">
      <img src="@/assets/img/album/202511/kankou_2.jpg" class="js-album-item">
      <img src="@/assets/img/album/202511/kankou_3.jpg" class="js-album-item">
      <img src="@/assets/img/album/202511/kankou_4.jpg" class="js-album-item">
      <img src="@/assets/img/album/202511/kankou_5.jpg" class="js-album-item">
      <img src="@/assets/img/album/202511/kankou_6.jpg" class="js-album-item">
      <img src="@/assets/img/album/202511/kankou_7.jpg" class="js-album-item">
      <img src="@/assets/img/album/202511/kankou_8.jpg" class="js-album-item">
      <img src="@/assets/img/album/202511/kankou_9.jpg" class="js-album-item">
      <img src="@/assets/img/album/202511/kankou_10.jpg" class="js-album-item">
      <img src="@/assets/img/album/202511/kankou_11.jpg" class="js-album-item">
      <img src="@/assets/img/album/202511/kankou_12.jpg" class="js-album-item">
      <img src="@/assets/img/album/202511/kankou_13.jpg" class="js-album-item">
      <img src="@/assets/img/album/202511/kankou_14.jpg" class="js-album-item">
      <img src="@/assets/img/album/202511/kankou_15.jpg" class="js-album-item">
      <img src="@/assets/img/album/202511/kankou_16.jpg" class="js-album-item">
      <img src="@/assets/img/album/202511/kankou_17.jpg" class="js-album-item">
      <img src="@/assets/img/album/202511/kankou_18.jpg" class="js-album-item">
      <img src="@/assets/img/album/202511/kankou_19.jpg" class="js-album-item">
      <img src="@/assets/img/album/202511/kankou_20.jpg" class="js-album-item">
      <img src="@/assets/img/album/202511/kankou_21.jpg" class="js-album-item">
      <img src="@/assets/img/album/202511/kankou_22.jpg" class="js-album-item">
      <img src="@/assets/img/album/202511/kankou_23.jpg" class="js-album-item">
      <img src="@/assets/img/album/202511/kankou_24.jpg" class="js-album-item">
      <img src="@/assets/img/album/202511/kankou_25.jpg" class="js-album-item">
    </div>
    
    <h3 class="mb-3">2025.11.21 フェアウェルパーティ</h3>
    <div class="album_wrap">
      <img src="@/assets/img/album/202511/farewell_1.jpg" class="js-album-item">
      <img src="@/assets/img/album/202511/farewell_2.jpg" class="js-album-item">
      <img src="@/assets/img/album/202511/farewell_3.jpg" class="js-album-item">
      <img src="@/assets/img/album/202511/farewell_4.jpg" class="js-album-item">
      <img src="@/assets/img/album/202511/farewell_5.jpg" class="js-album-item">
      <img src="@/assets/img/album/202511/farewell_6.jpg" class="js-album-item">
      <img src="@/assets/img/album/202511/farewell_7.jpg" class="js-album-item">
      <img src="@/assets/img/album/202511/farewell_8.jpg" class="js-album-item">
      <img src="@/assets/img/album/202511/farewell_9.jpg" class="js-album-item">
      <img src="@/assets/img/album/202511/farewell_10.jpg" class="js-album-item">
      <img src="@/assets/img/album/202511/farewell_11.jpg" class="js-album-item">
      <img src="@/assets/img/album/202511/farewell_12.jpg" class="js-album-item">
      <img src="@/assets/img/album/202511/farewell_13.jpg" class="js-album-item">
      <img src="@/assets/img/album/202511/farewell_14.jpg" class="js-album-item">
      <img src="@/assets/img/album/202511/farewell_15.jpg" class="js-album-item">
    </div>
    
  </section>


  <!-- トップに戻るボタン -->
  <button id="page-top" class="btn" v-on:click="scrollTop">
    TOP
  </button>

  <!-- 画像拡大用 -->
  <div id="modal_overlay">
    <span class="close_btn">&times;</span>
    <img id="modal_img">
  </div>

</template>

<style scoped>
.album_wrap {
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
  align-items: center;
  gap: 10px;
  margin-bottom: 50px;
}

.album_wrap img {
    width: 32%;
    aspect-ratio: 4 / 3; 
  object-fit: cover;
  object-position: center;
}

.column_content h2,.column_content h3 {
  font-weight: 500 !important;
}

small {
  font-size: .7em;
}

button#page-top {
  position: fixed;
  left: 20px;
  bottom: 20px;
  z-index: 100;
}

/* 拡大表示時の背景（オーバーレイ） */
#modal_overlay {
  display: none; /* 初期は非表示 */
  position: fixed;
  z-index: 1000;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.9); /* 背景を暗く */
  align-items: center;
  justify-content: center;
  cursor: zoom-out;
}

/* 拡大画像本体 */
#modal_img {
  max-width: 90%;
  max-height: 90%;
  object-fit: contain;
  animation: zoomIn 0.3s; /* ふわっと表示させる */
}

/* 閉じるボタン */
.close_btn {
  position: absolute;
  top: 20px;
  right: 30px;
  color: #fff;
  font-size: 40px;
  cursor: pointer;
}

@keyframes zoomIn {
  from { transform: scale(0.8); opacity: 0; }
  to { transform: scale(1); opacity: 1; }
}

@media screen and (max-width: 768px) {
  .album_wrap img {
    width: 100%;
  }
}
</style>

<script>
import $ from "jquery";

$(function() {
 var topBtn = $('#page-top');    
 topBtn.hide();
 //スクロールが500に達したらボタン表示
 $(window).scroll(function () {
 if ($(this).scrollTop() > 500) {
 topBtn.fadeIn();
        } else {
 topBtn.fadeOut();
        }
    }); 
});



// ページ内リンク
export default{
  data: () => {
    return {isActive: []}
  },
  mounted (){
    window.scroll(0, 0);
    for(let i = 0; i < 2; i++) {
      this.isActive[i] = false
    }

    const items = document.querySelectorAll('.js-album-item');
    const overlay = document.getElementById('modal_overlay');
    const modalImg = document.getElementById('modal_img');
    const closeBtn = document.querySelector('.close_btn');

    // 画像クリック時の処理
    items.forEach(item => {
      item.addEventListener('click', () => {
        modalImg.src = item.src;
        overlay.style.display = 'flex';
        document.body.style.overflow = 'hidden';
      });
    });

    // 閉じる処理（オーバーレイまたは×ボタン）
    [overlay, closeBtn].forEach(el => {
      el.addEventListener('click', () => {
        overlay.style.display = 'none';
        document.body.style.overflow = '';
      });
    });

  },
  methods: {
    scrollToAnchorPoint(refName) {
      const el = this.$refs[refName]
      el.scrollIntoView({ behavior: 'smooth'})
    },
    openInfo(ref) {
      console.log(ref)
      this.isActive[ref] = true
      console.log(this.isActive[ref])
    },
    closeInfo(ref) {
      console.log(ref)
      this.isActive[ref] = false
      console.log(this.isActive[ref])
    },
    scrollTop(){
      window.scrollTo({
      top: 0,
      behavior: "smooth"
      })
    }
  }
}

</script>